import { useRouter } from 'next/router'

import {
  inferPageSource,
  PageSource,
  PrePaywallPageSource,
} from '@mc/track-event'

const VALID_PAGE_SOURCES = [
  PageSource.HOMEPAGE,
  PageSource.CLASS_PAGE,
  PageSource.SERIES_PAGE,
  PageSource.CATEGORY,
  PageSource.SUBCATEGORY,
  PageSource.SESSIONS_HOME,
  PageSource.SESSIONS_CLASS,
  PageSource.OUTCOME,
] as PrePaywallPageSource[]

export const usePageSource = () => {
  const router = useRouter()

  const pathname =
    typeof window !== 'undefined' ? window.location.pathname : router.pathname

  return inferPageSource(pathname)
}

export const useMoneyBackPricingMicrocopy = () => {
  const pageSource = usePageSource()

  return VALID_PAGE_SOURCES.includes(pageSource)
}
